/**
 * All user-visible static text for ManageWhitelistDomain component
 * and ManageWhitelistDomainContext toast messages.
 */

// ── Navigation ─────────────────────────────────────────────────────────────
export const MANAGE_WHITELIST_BREADCRUMB = ["User Access Management", "Domain Whitelist"];

// ── Page header ────────────────────────────────────────────────────────────
export const PAGE_TITLE = "Manage Domain Whitelisting";
export const PAGE_DESCRIPTION = "Manage and monitor all domain whitelisting requests.";
export const BTN_ADD_DOMAIN    = "+ Add Domain";
export const BTN_UPLOAD_DOMAIN = "Upload Domain";
export const BTN_WHITELIST     = "Whitelist Domain";
export const BTN_REMOVE_WHITELIST = "Remove Whitelist";

// ── Summary cards ──────────────────────────────────────────────────────────
export const CARD_TOTAL_VENDORS    = "TOTAL";
export const CARD_WHITELISTED      = "DOMAINS WHITELISTED";
export const CARD_PENDING_WHITELIST = "PENDING WHITELIST";
export const CARD_DOMAIN_BLOCKED  = "BLOCKED DOMAINS";

// ── Grid toolbar ───────────────────────────────────────────────────────────
export const SEARCH_PLACEHOLDER   = "Search...";
export const BTN_CLEAR_FILTERS    = "Clear Filters";
export const BTN_DOWNLOAD         = "DOWNLOAD";

// ── Column headers ─────────────────────────────────────────────────────────
export const COL_AL_IDENTIFIER  = "AL Identifier";
export const COL_REQUEST_NO     = "Request No.";
export const COL_DOMAIN_NAME    = "Domain Name";
export const COL_APPLICATION_NAME = "Application Name";
export const COL_REQUESTED_BY   = "Requested By";
export const COL_REQUEST_DATE   = "Request Date";
export const COL_STATUS         = "Status";

/** Returns the CSV export filename with today's date */
export const getExportFilename = () =>
  `domain-whitelist-${new Date().toISOString().slice(0, 10)}.csv`;

// ── Context toast messages ─────────────────────────────────────────────────
export const TOAST_FETCH_DOMAIN_ERROR   = "Failed to fetch domain list.";
export const TOAST_FETCH_SUMMARY_ERROR  = "Failed to fetch dashboard summary.";
export const TOAST_UPLOAD_SUCCESS       = (count) => `Upload successful: ${count}`;
export const TOAST_UPLOAD_PARTIAL       = (success, failed) =>
  `Uploaded: ${success}, Failed: ${failed}.`;
export const TOAST_UPLOAD_ERROR         = "Upload failed.";
export const BTN_VIEW_FAILED_DOMAINS    = "View Failed Domains";
export const FAILED_DOMAINS_DIALOG_TITLE = "Failed Domains";
export const BTN_CLOSE                  = "Close";
export const TOAST_ADD_DOMAIN_ERROR     = "Something went wrong. Please try again.";
export const TOAST_WHITELIST_SUCCESS    = "Domains whitelisted successfully.";
export const TOAST_WHITELIST_ERROR      = "Failed to whitelist domains.";
export const TOAST_REMOVE_SUCCESS       = "Domains removed from whitelist.";
export const TOAST_REMOVE_ERROR         = "Failed to remove whitelist.";
